import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getAdmins = createAsyncThunk(
  "Employees/getAdmins",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addAdmins = createAsyncThunk(
  "Employees/addAdmins",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateAdmins = createAsyncThunk(
  "Employees/updateAdmins",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteAdmins = createAsyncThunk(
  "Employees/deleteAdmins",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getCompanies = createAsyncThunk(
  "Employees/getCompanies",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/companies`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addCompanies = createAsyncThunk(
  "Employees/addCompanies",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/companies`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateCompanies = createAsyncThunk(
  "Employees/updateCompanies",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/companies/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteCompanies = createAsyncThunk(
  "Employees/deleteCompanies",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/companies/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

const EmployeesSlice = createSlice({
  name: "Employees",
  initialState: {
    isEmployeesLoading: false,
    error: null,
    adminsArray: null,
    CompaniesArray: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.adminsArray = action.payload.data;
      })
      .addCase(getAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(addAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(addAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(addAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(updateAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(updateAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(updateAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(deleteAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(deleteAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.adminsArray = state.adminsArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(getCompanies.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getCompanies.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.CompaniesArray = action.payload.data;
      })
      .addCase(getCompanies.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(addCompanies.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(addCompanies.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(addCompanies.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(updateCompanies.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(updateCompanies.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(updateCompanies.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(deleteCompanies.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(deleteCompanies.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.CompaniesArray = state.CompaniesArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteCompanies.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      });
  },
});

export default EmployeesSlice.reducer;
